<template>
  <div class="translate-box" @mouseover="showPickerPopup" @mouseout="closePicker">
    <!-- translate-bar -->
    <div class="translate-bar">
      <span class="link-text" :title="$t('translateEmail')">
        <img src="@/assets/svg/translate.svg" class="translate-icon" /></span>
    </div>

    <!-- language popup -->
    <div v-show="showPicker" class="popup-box">
      <div class="pick-header">
        <div class="title">{{ $t("selectTranslateLan") }}</div>
      </div>
      <ul class="lanList">
        <div v-for="item in columns" :key="item.value">
          <li @click="onConfirm(item)"
            :class="item.value === currentLan ? 'selected' : ''">
            <div>{{ item.value === 'origin' ? $t(item.label) : item.label }}</div>
          </li>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: 'TranslateBar',
 
  data() {
    return {
      columns: [{
        label: '中文',
        value: 'zh-cn'
      },
      {
        label: 'English',
        value: 'en'
      },
      {
        label: 'showOrigin',
        value: 'origin'
      }
      ],
      currentLan: 'origin',
      showPicker: false,
      setTimeout: null
    }
  },

  methods: {

    showPickerPopup() {
      if (this.setTimeout) {  
        clearTimeout(this.setTimeout);
      }
      this.showPicker = true
    },

    closePicker() {
      this.setTimeout = setTimeout(() => {
        this.showPicker = false;
      }, 500)
    },

    onConfirm(data) {
      let lang = data.value
      this.currentLan = lang;
      if(lang !== 'origin') {
        this.$i18n.locale = lang;
        this.$store.commit("updataLocale", lang);
      }else {
        this.$i18n.locale = 'zh-cn';
        this.$store.commit("updataLocale", 'zh-cn');
      }
      this.$store.commit("updataLanguage", lang);
      this.showPicker = false;
    },
  }
};
</script>

<style scoped lang="scss">
.translate-box {
  position: relative;
  color: #333;
  .translate-bar {
    font-size: 14px;
    background: #fff;
    width: 30px;
    height: 30px;
    border-radius: 30px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    .translate-icon {
      width: 20px;
      margin-top: -3px;
    }
  }

  .popup-box {
    position: absolute;
    right: 0;
    top: 35px;
    z-index: 1000;
    border-radius: 4px;
    padding: 8px;
    background: #fff;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.12);

    .pick-header {

      .title {
        color: #AEADB9;
        font-size: 12px;
        padding: 8px;
        white-space: nowrap;
      }

      .close-icon {
        font-size: 14px;
        color: #666;
        cursor: pointer;
      }
    }

    .lanList {
      li {
        padding: 0 8px;
        height: 36px;
        min-width: 148px;
        line-height: 36px;
        border-radius: 4px;
        cursor: pointer;
      }

      li:hover {
        background: rgba(0, 93, 229, 0.06);
      }

      .selected {
        color: #296AB4;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/translate/index.vue